import checkboxGroup from '../checkbox/checkbox-group'

export default checkboxGroup



// WEBPACK FOOTER //
// ./components/components/checkbox-group/index.js